import { createApp } from 'vue';
import App from '@/js/vue-components/pages/urban/fund/App.vue';
import store from '@/js/urban/fund/index.js';

createApp({
    components: {
        App
    }
})
    .use(store)
    .mount('#app');
